import { apiClient } from '../client';
import type { AsyncTasksListParams, AsyncTasksListResponse } from './types';

export const asyncTasksQueryKeys = {
  all: ['async_tasks'] as const,
  lists: () => [...asyncTasksQueryKeys.all, 'list'] as const,
  list: (params?: AsyncTasksListParams) =>
    [...asyncTasksQueryKeys.lists(), params] as const,
};

export async function getAsyncTasks(
  params?: AsyncTasksListParams
): Promise<AsyncTasksListResponse> {
  const response = await apiClient.get<AsyncTasksListResponse>(
    '/api/async_tasks',
    { params }
  );
  return response.data;
}
